var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: "top", appear: "" } },
    [
      _c(
        "q-page-sticky",
        { attrs: { position: "top-right", offset: [11, 11] } },
        [
          _c(
            "q-tooltip",
            {
              attrs: { self: "center right", anchor: "center left", delay: 500 }
            },
            [_vm._v(_vm._s(_vm.btns[0].tooltip))]
          ),
          _vm._v(" "),
          _vm.aux[0]
            ? _c(
                "q-btn-dropdown",
                {
                  attrs: {
                    rounded: "",
                    align: "right",
                    split: "",
                    "content-class": "pop-dd",
                    color: _vm.btns[0].color,
                    icon: _vm.btns[0].icon
                  },
                  on: { click: _vm.btns[0].click }
                },
                _vm._l(_vm.aux, function(btn, index) {
                  return !btn.hide
                    ? _c(
                        "q-btn",
                        {
                          key: index,
                          attrs: {
                            color: btn.color,
                            icon: btn.prefix ? "" : btn.icon,
                            round: ""
                          },
                          on: { click: btn.click }
                        },
                        [
                          btn.tooltip
                            ? _c(
                                "q-tooltip",
                                {
                                  attrs: {
                                    self: "center right",
                                    anchor: "center left",
                                    delay: 500
                                  }
                                },
                                [_vm._v(_vm._s(btn.tooltip))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          btn.prefix
                            ? [
                                _c("span", [_vm._v("+")]),
                                _vm._v(" "),
                                _c("q-icon", {
                                  attrs: { name: btn.icon, size: "20px" }
                                })
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e()
                })
              )
            : _c("q-btn", {
                attrs: {
                  round: "",
                  color: _vm.btns[0].color,
                  icon: _vm.btns[0].icon
                },
                on: { click: _vm.btns[0].click }
              })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57c79dc0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57c79dc0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pop-btn.vue
// module id = null
// module chunks = 